/* global axios */
import ApiClient from './ApiClient';

class RasasAPI extends ApiClient {
  constructor() {
    super('rasas', { accountScoped: true });
  }
}

export default new RasasAPI();
